import React, { useEffect } from 'react';
import { Carousel } from 'antd';
import slide1 from '@src/assets/images/dashboard/mua-sam.jpg';
import slide2 from '@src/assets/images/dashboard/mua-sam-1.jpg';

const Home: React.FC<any> = () => {
  useEffect(() => {
    /* request("@src/admin/banner/get-list-banner").then((rs: any) => {
      if (rs.data?.data) {
        setListBanner(rs.data?.data);
      }
    }); */
  }, []);

  return (
    <React.Fragment>
      <div>
        <Carousel autoplay>
          <div>
            <img
              src={slide1}
              style={{
                maxHeight: '600px',
                objectFit: 'cover',
              }}
            />
          </div>
          <div>
            <img
              src={slide2}
              style={{
                maxHeight: '600px',
                objectFit: 'cover',
              }}
            />
          </div>
        </Carousel>
      </div>
    </React.Fragment>
  );
};

export default Home;
